import { ReactNode } from 'react';
import { useActivePersona } from './useActivePersona';
import { resolveView } from './resolveView';
import type { PersonaRoute } from './types';

type PersonaViewProps = {
  /** Vilken route detta gäller — används för persona-override-uppslag i views. */
  route: PersonaRoute;
  /** Brukar-vyn (renderas för child när ingen persona-override finns). */
  child: ReactNode;
  /** Vuxen-/handledarvyn (renderas i vuxenläge). */
  adult: ReactNode;
};

/**
 * Persona-medveten route-växel (efterföljaren till ChildRouteSwitch). Gaten sker
 * i KOMPONENTEN via useActivePersona:
 *   - vuxen-profil → adult-vyn direkt.
 *   - teen → resolvar via views-map, faller tillbaka på child om view saknas.
 *   - child → child-vyn (fallback).
 */
const PersonaView = ({ route, child, adult }: PersonaViewProps) => {
  const profile = useActivePersona();
  if (profile.persona === 'adult') return <>{adult}</>;
  const view = resolveView(profile, route, () => child);
  return <>{view()}</>;
};

export default PersonaView;
